import { useNavigate } from "react-router-dom";

import { AdminTag, Button, UserAvatar } from "@/components";
import { useAppProperties, useUserDetails } from "@/hooks";
import { User02 } from "@/icons";
import { useTranslate, useUser } from "@/providers/context";

import { Separator } from "./Separator.tsx";

/*
  The profile picture, name and email of the user
 */

export const ProfileHeader = () => {
  const { data } = useUserDetails();
  const { translate } = useTranslate();
  const { uid, loggedInUserIsAdmin } = useUser();
  const navigate = useNavigate();
  const { rolloutEditProfile } = useAppProperties();
  const isSignedIn = !!uid;
  const name = `${data?.first_name ?? ""} ${data?.last_name ?? ""}`;

  return (
    <>
      <div className="mt-[60px] flex w-[500px] flex-col items-center">
        {isSignedIn ? (
          <UserAvatar
            className="mb-[24px] h-[108px] w-[108px] text-[50px]"
            name={name}
            imageUrl={data?.avatar_url}
          />
        ) : (
          <div className="mb-[24px] flex h-[108px] w-[108px] cursor-default items-center justify-center rounded-full bg-border">
            <User02 className="h-[60px] w-[60px] text-white" />
          </div>
        )}
        <div className="flex items-center justify-center gap-2">
          <div className="p1-bold w-full overflow-hidden overflow-ellipsis whitespace-nowrap text-center">
            {isSignedIn ? name ?? "" : "You're not signed in"}
          </div>
          {loggedInUserIsAdmin && <AdminTag />}
        </div>
        <div className="p2-regular mt-[8px] w-full overflow-hidden overflow-ellipsis whitespace-nowrap text-center">
          {data?.email}
        </div>
        {rolloutEditProfile && (
          <Button
            variant="edit"
            size="s"
            className="mt-2"
            onClick={() => navigate("/profile-update")}
          >
            {translate("Edit Profile")}
          </Button>
        )}
      </div>
      <Separator />
    </>
  );
};
